// https://www.ag-grid.com/react-data-grid/getting-started/
// https://ag-grid.com/javascript-data-grid/filtering-overview/?ref=blog.ag-grid.com
// https://www.ag-grid.com/javascript-data-grid/csv-export/
// https://medium.com/@jwag/persisting-state-for-ag-grid-saving-column-order-filters-and-sort-options-e62f18332ebd

// npm i ag-grid-react
import { AgGridReact } from 'ag-grid-react';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
ModuleRegistry.registerModules([AllCommunityModule]);

// https://www.ag-grid.com/react-data-grid/themes/
// https://www.ag-grid.com/react-data-grid/theming-migration/
// import { themeMaterial as agGridTheme  } from 'ag-grid-community';
// const agGridTheme = themeMaterial.withParams({ accentColor: 'red' });

// import and install only the used ones to decrease file size
/*
import {
	AlignedGridsModule,
    CellApiModule,
    CellSpanModule,
    CellStyleModule,
    CheckboxEditorModule,
    ClientSideRowModelApiModule,
    ClientSideRowModelModule,
    ColumnApiModule,
    ColumnAutoSizeModule,
    ColumnHoverModule,
    CsvExportModule,
    CustomEditorModule,
    CustomFilterModule,
    DateEditorModule,
    DateFilterModule,
    DragAndDropModule,
    EventApiModule,
    ExternalFilterModule,
    GridStateModule,
    HighlightChangesModule,
    LargeTextEditorModule,
    LocaleModule,
    NumberEditorModule,
    NumberFilterModule,
    PaginationModule,
    PinnedRowModule,
    QuickFilterModule,
    RenderApiModule,
    RowApiModule,
    RowAutoHeightModule,
    RowDragModule,
    RowSelectionModule,
    RowStyleModule,
    ScrollApiModule,
    SelectEditorModule,
    TextEditorModule,
    TextFilterModule,
    TooltipModule,
    UndoRedoEditModule,
    ValidationModule,
    ValueCacheModule,
} from 'ag-grid-community';

ModuleRegistry.registerModules([
    AlignedGridsModule,
    CellApiModule,
    CellSpanModule,
    CellStyleModule,
    CheckboxEditorModule,
    ClientSideRowModelApiModule,
    ClientSideRowModelModule,
    ColumnApiModule,
    ColumnAutoSizeModule,
    ColumnHoverModule,
    CsvExportModule,
    CustomEditorModule,
    CustomFilterModule,
    DateEditorModule,
    DateFilterModule,
    DragAndDropModule,
    EventApiModule,
    ExternalFilterModule,
    GridStateModule,
    HighlightChangesModule,
    LargeTextEditorModule,
    LocaleModule,
    NumberEditorModule,
    NumberFilterModule,
    PaginationModule,
    PinnedRowModule,
    QuickFilterModule,
    RenderApiModule,
    RowApiModule,
    RowAutoHeightModule,
    RowDragModule,
    RowSelectionModule,
    RowStyleModule,
    ScrollApiModule,
    SelectEditorModule,
    TextEditorModule,
    TextFilterModule,
    TooltipModule,
    UndoRedoEditModule,
    ValidationModule,
    ValueCacheModule,
]);
*/
// npm i @ag-grid-community/locale
import { AG_GRID_LOCALE_ES, AG_GRID_LOCALE_EN } from '@ag-grid-community/locale';

import { useRef, useState, useEffect } from "react";

import { cleanString } from '@/utils/Format';
import { date } from '@/utils/Dates';

import { formatColumns, columnIsEditable, getEditableColumn, checkCanFit } from '@/utils/Columns';

import { getTableConfig, setTableConfig } from '@/utils/Table';

import { checkErrors } from "@/utils/Errors.jsx";

export default function TableGrid({
	t,language,user,/*router,*/table,config,columns,rows,api,setApi,editable,modal,loading/*,rowData*/,
	handleEdition,setEditDisabled,setSavedEnabled,setDeleteDisabled,setAddDisabled,setShareDisabled,
	setFiltersApplied,handleButtonView/*,handleButtonAdd*/,handleButtonEdit,handleButtonDelete,handleButtonShare,paginationPageSize,
	enableAdd,enableEdit,openUrlModal,onRowSelected,setNumRenderedNodes,
    handleEdit,setRender,handleTableItemSelected,sendMessage,headerFixed
	/*,enableDelete*/,/*,autoSizeStrategy*/
}){

	const gridRef = useRef(null);

	// translation for the table
	// node_modules/@ag-grid-community/locale/dist/umd/@ag-grid-community/locale.js
	const [ localeText ] = useState(
		!language ?
            		AG_GRID_LOCALE_EN 
            	: 
            		language === 'es' ? 
            			AG_GRID_LOCALE_ES
            		: 
            			language === 'ca' ? 
            				AG_GRID_LOCALE_ES
            			:
            				AG_GRID_LOCALE_EN
	);
	localeText.page = 'Pg.';
	localeText.pageSizeSelectorLabel = '';
	localeText.of = '/';

	const [ tableColumns, setTableColumns ] = useState([]);

	// to recover columns states if saved
	/*	
	const recoverColumnsState = (formattedTableColumns) => {

		var tableState = getTableConfig(user,table,'columnState');
    	//apiTable?.applyColumnState({state:tableConfig?.columnState,applyOrder: true});	
    	//apiTable?.setColumnGroupState(tableConfig?.groupState);
    	
    	if(tableState && Object.keys(tableState).length > 0){

    		var sameColumns = [];
    		
    		// set the saved sorting
    		formattedTableColumns.map((formattedColumn,index) => {
    			
    			var field = formattedColumn?.field;
    			var columnStateArray = tableState.filter((item) => item?.colId === field);

    			if(columnStateArray && columnStateArray?.length > 0){	    				
    				
    				var columnState = columnStateArray[0];
    				sameColumns.push(field);

    				if(columnState && Object.hasOwn(columnState,'sort')){
    					formattedColumn.sort = columnState.sort;
    				}

    				if(columnState && Object.hasOwn(columnState,'sortIndex')){
    					formattedColumn.sortIndex = columnState.sortIndex;
    				}

    				formattedTableColumns[index] = formattedColumn;
    			}
    		});	 	    		

    		// if same columns, check column order. if not the same, do not get the saved one because
    		// there are new columns	    		
    		if(formattedTableColumns.length === sameColumns.length){

    			var newOrder = [];
    			tableState.map((columnState,index) => {

    				var colId = columnState?.colId;	    				
    				var formattedColumnArray = formattedTableColumns.filter((item) => item?.field === colId);

    				if(formattedColumnArray && formattedColumnArray?.length > 0){
    					newOrder.push(formattedColumnArray[0]);
    				}
    			});
    			formattedTableColumns = newOrder;
    		}
    		else{
    			// remove previous config
    			removeTableConfig(user,table,'columnState');
    		}
    	}

    	return formattedTableColumns;
    }
    */

    // format the columns
    useEffect(() => {

    	if(columns && Object.keys(columns).length > 0){    		

        	var formattedTableColumns = formatColumns(t,user,table,columns,handleEdition,modal,editable,
        		handleButtonView,handleButtonEdit,handleButtonDelete,handleButtonShare,openUrlModal);
        	
        	// recover previous state if any
        	//var recoveredTableColumns = recoverColumnsState(formattedTableColumns);
        	//setTableColumns(recoveredTableColumns);        	
        	setTableColumns(formattedTableColumns);
        }
        else{
        	setTableColumns([]);
        }
    },[columns]);

    // on grid ready does not have api working, so using this
    // this is called for every table if you move among GenericTable
    // not using first data rendered because if table with empty rows it is not called    
    //const handleFirstDataRendered = (params) => {

    const handleGridReady = (params) => {
    	
    	var apiTable = params?.api;
    	setApi(apiTable); 
		
		// recover table config
		var tableConfig = getTableConfig(user,table);
		
		// get the heights

        // height for the rows
        var rowsHeight = null;
        if(tableConfig && Object.hasOwn(tableConfig,'rowsHeight')){
        	rowsHeight = tableConfig.rowsHeight ? tableConfig.rowsHeight : null;
        }
        else{
	        if(config && Object?.hasOwn(config,'rowsheight')){
	        	// if 0 use null that means auto height for the rows
	        	rowsHeight = config.rowsheight ? config.rowsheight : null;        	
	        }
	    }

		// without timeout it does not work
		setTimeout(() => {
			
			// filters
			if(tableConfig?.filterState){
				apiTable?.setFilterModel(tableConfig?.filterState);
			}

			/*
			already apply on formatColumns
			if(tableConfig?.columnState){
				apiTable?.applyColumnState({state:tableConfig?.columnState,applyOrder: true});
			}
			*/

			if(tableConfig?.groupState){
				apiTable?.setColumnGroupState(tableConfig?.groupState);
			}

			// visibility. if nothing saved, show all
			/*
			already apply on formatColumns
			if(visible && visible.length > 0){
				apiTable?.setColumnsVisible(visible,true);
			}
			*/

			/*
			already apply on formatColumns
			if(invisible && invisible.length > 0){
    			apiTable?.setColumnsVisible(invisible,false);
    		}
			*/

    		// check table and columns width
			// already apply on formatColumns
    		//setTableWidths(apiTable,tableConfig,visible,sizes/*,autosizes*/);
			
			// check if autowidth if no sizes configured
			setTableAutoWidth(apiTable);

    		// set heights

    		// rows height
    		apiTable.setGridOption('rowHeight',rowsHeight); 

    		// columns adjust to content
			// already apply on formatColumns
    		//setTableHeights(apiTable,tableConfig,columnAutoHeight);

		},0);
		
		// when api ready, create listener to resize the table when resizing the browser
    	window.addEventListener('resize', () => {
    		setTableAutoWidth(apiTable);
		});
    }

	// check if autowidth if no widths configured
	const setTableAutoWidth = (apiTable) => {

		const tableConfig = getTableConfig(user,table);
		
		const columnsKeys = columns && Object.keys(columns) ? Object.keys(columns) : null;

		// check only on visible columns
		const visible = [];	    
		columnsKeys && columnsKeys?.map((column) => {
	            
            if(tableConfig && tableConfig?.columnVisibility && Object.hasOwn(tableConfig?.columnVisibility,column)){
            
                if(tableConfig?.columnVisibility[column]){
                	visible.push(column);
                }
            }
            else{
            	// if the column is not on the config, check visible parameter coming from backend            	
            	if(columns[column] && Object.hasOwn(columns[column],'visible')){
            		if(columns[column].visible){
            			visible.push(column);
            		}
            	}
            	else{
            		// show it
                	visible.push(column);
                }
            }
        });

		if(visible && visible.length > 0){
			
			// widths
			let widths = false;
			visible?.forEach((column) => {	
				
				if(widths){
					return;
				}
				
				if(tableConfig && tableConfig?.columnSize && Object.hasOwn(tableConfig?.columnSize,column)){
				
					// if 0 or null, it is not width
					if(tableConfig?.columnSize[column]){
						widths = true;
					}
				}
				else{
					// check if any width from backend
					// if 0 or null, it is not width
					let settings = columns[column];
					if(settings?.width){
						widths = true;
					}
				}

			});

			if(!widths){							
				
				let fit = false;
				if(tableConfig && Object.hasOwn(tableConfig,'fit') && tableConfig.fit){
					fit = true;
				}
				else{
					// if fit to screen from backend config, apply it
					if(config?.fit){
						fit = true;
					}
				}

				if(fit){
					// if fit by config, fit to grid    
					// but only if the screen is wide enough	
					const canFit = checkCanFit(table,visible);
					if(canFit){
						apiTable.sizeColumnsToFit();
					}
				}
			}
		}		
    }

    // when changing the sorting column
    const handleSortChanged = (params) => {    	
    	
    	var apiTable = params?.api;

    	if(apiTable){
    		setTableConfig(apiTable,user,table,'columnState');
    		//setTableConfig(apiTable,user,table,'groupState');    	
    	}
    }

    // when changing the column order
    const handleColumnMoved = (params) => {
    	
    	var apiTable = params?.api;
    	
    	if(apiTable){
    		setTableConfig(apiTable,user,table,'columnState');
    		//setTableConfig(apiTable,user,table,'groupState');
    	}
    }

    // when resizing column
    const handleColumnResized = (params) => {
    	
    	// params.source
    	// autosizeColumns => api.autoSizeColumns({scaleUpToFitGridWidth:true})
    	// uiColumnResized => drag and drop
    	// api => api?.setColumnWidths();
    	const source = params?.source;
    	var apiTable = params?.api;
    	
    	// if resized with drag and drop
    	// to avoid executing when resizing with config	
    	if(apiTable && source === 'uiColumnResized'){
    		
    		var sizes = getTableConfig(user,table,'columnSize');
    		if(!sizes){
    			sizes = {};
    		}
    		
    		params?.columns && params.columns?.map((column) => {    			
    			sizes[column?.colId] = column?.actualWidth;
    		});

    		setTableConfig(apiTable,user,table,'columnSize',sizes);
    		//setTableConfig(apiTable,user,table,'columnState');    		
    	}
    	
    }

	// detect start editing, to change button from edit to save
	const handleEditStart = (/*params*/) => {

		setEditDisabled(false);
		setSavedEnabled(true);

		// disable add unless we don't have edit button because we are forcing enableAdd
		//if(!modal && !editable && enableAdd && !enableEdit){ => the opposite to this
		if(modal || editable || !enableAdd || enableEdit){		
			setAddDisabled(true);
		}
	}

	// when stop editing, save the row
	const handleEditStop = (params) => {

        const apiTable = params?.api;
        const node = params?.node;
        const data = node?.data;

        // if node udpated, save it
        // if updated is undefined, save it because it is a mouse event
        if(!Object?.hasOwn(node,'updated') || node?.updated){ 

            var errorsCheck = null;

            // if mouse event, check errors and reopen edit
            if(!Object?.hasOwn(node,'updated')){
                errorsCheck = checkErrors(t,table,apiTable,node,modal,columns,data,sendMessage,'save',true);
            }

            if(!errorsCheck || Object.keys(errorsCheck).length === 0){
                handleEdit('save',apiTable,node,data,setSavedEnabled,setAddDisabled,null,setRender,handleTableItemSelected);
            }
        }
        else{
            setSavedEnabled(false);
            setAddDisabled(false);
        }
	}

    // to copy cell value to clipboard
    const copyToClipboard = (column,node,value) => {

        const colDef = column?.getColDef();
        
        // use same value as valueFormatter (used to export)        
        if(colDef.valueFormatter){
            
            const params = {
                value: value,
                data: node.data,
                node: node,
                column: column,
                colDef: colDef
            };

            value = colDef.valueFormatter(params);
        }

        navigator.clipboard.writeText(value);
    }

    // to paste the clipboard on the cell and open edit mode
    async function pasteClipboard(apiTable,node,rowIndex,column){

        try{            
            const pasted = await navigator.clipboard.readText();            
            node?.setDataValue(column,pasted);

            setTimeout(() => {

                apiTable?.startEditingCell({
                    rowIndex: rowIndex,
                    colKey: column
                });

            },0);

            setSavedEnabled(true);
            setAddDisabled(true);

            return pasted;

        }
        catch(err){
            if(err){
                return null;
            }
        }
    }

	const onCellKeyDown = (params) => {

		const apiTable = params?.api;

		const keyCode = params?.event?.keyCode;

		const id = params?.data?.id;
		
		//const api = gridRef?.current?.api;
		const node = params?.node;
        const rowIndex = params?.rowIndex;
        const columnDef = params?.column?.colDef;
		const column = columnDef?.colId;		

        // check if the row/cell of the current cell is in edit mode
        // ESC and ENTER do not detect edit mode
        const cellsEditing = apiTable?.getEditingCells();
        
        // check if the row of the current cell is in edit mode
        // not valid because the row can be in edit mode but not the cell
        // because it is not editable, for example
        /*
        const rowEditing = cellsEditing.some(cellsEditing => {
            return cellsEditing.rowIndex === rowIndex;
        });
        */

        // check if cell in edit mode
        const cellEditing = cellsEditing.some(cellsEditing => {
            return cellsEditing.rowIndex === rowIndex && cellsEditing.column.getId() === column;
        });

        // valid if in edit mode or not
        //var value = params?.event?.target?.value;
        const value = node?.data[column];
        
		// ESC
		if(keyCode === 27){

            // if new row, remove it
            if(!id){

                apiTable?.applyTransaction({
                    "remove": [node?.data]
                });

                setEditDisabled(true);
                setDeleteDisabled(true);                
                setSavedEnabled(false); 
                setAddDisabled(false);  
                setShareDisabled(true);
            }
            else{
                // change buttons. esc exits from row edition automatically
                setSavedEnabled(false);
                setAddDisabled(false);
            }
		}
		else{
			// if ENTER and not in edit mode, open it.
            // if in edit mode, save
			// for dropdown it does not detect the change, so cannot use onRowValueChanged
			if(keyCode === 13){		

                // here is the opposite
                // if in edit mode, it is after clicking ENTER, so it means we were NOT in edit mode
                // so save if coming from not editing
                /*
                if(!cellEditing){			
				    handleValueChanged(params,'row','enter');
                }
                */

                // we have changed the behaviour for the enter key to avoid sending api.stopEditing()
                // so now we keep in edit mode to check errors before saving
                // the code is in suppressKeyboardEvent
			}
			else{
				
				// detect cut to empty the cell. it is not done by default unless you change the focus
				// so if clicking a button, it is not detected
				
				// ctrl+x or cmd+x on mac				
				if((params?.event?.ctrlKey || params?.event?.metaKey) && keyCode === 88){

                    // empty cell
                    //params?.node?.setDataValue(column,'');

                    //setCutValue(value);

                    // if not in edit mode, copy to clipboard, remove value and open edit mode
                    if(!cellEditing){
                        
                        //navigator.clipboard.writeText(value);
                        copyToClipboard(params?.column,node,value);

                        // start edit mode if cell editable                        
                        const columnEditable = columnIsEditable(columnDef);
                        if(columnEditable){

                            setTimeout(() => {

                                apiTable?.startEditingCell({
                                    rowIndex: rowIndex,
                                    colKey: column
                                });

                            },0);
                            
                            // empty value because we are cutting
                            node?.setDataValue(column,null);

                            setSavedEnabled(true);
                            setAddDisabled(true);
                        }                        
                    }
					
				}
				else{
					// ctrl+v or cmd+v on mac
					if((params?.event?.ctrlKey || params?.event?.metaKey) && keyCode === 86){
						
                        // save pasted value	

						// value is empty if cut and paste immediately. so using setCutValue
						/*if((!value || value?.length === 0) && (cutValue && cutValue?.length > 0)){
							value = cutValue;
						}*/		
								
						//node?.setDataValue(column,value);

                        // if not in edit mode, open edit mode and paste the value
                        if(!cellEditing){
                            
                            // start edit mode if cell editable                        
                            const columnEditable = columnIsEditable(columnDef);
                            if(columnEditable){                                
                                pasteClipboard(apiTable,node,rowIndex,column);
                            } 
                        }
					}
					else{
                        // ctrl+c or cmd+c => copy the value to the clipboard
                        if((params?.event?.ctrlKey || params?.event?.metaKey) && keyCode === 67){
                            
                            // if not in edit mode, copy to clipboard
                            if(!cellEditing){
                                //navigator.clipboard.writeText(value);
                                copyToClipboard(params?.column,node,value);
                            }                            
                        }
                        else{
    						// backspace or supr
    						if(keyCode === 8 || keyCode === 46){
    							
                                //node?.setDataValue(column,value);

                                // if not in edit mode, open edit mode and empty the value
                                if(!cellEditing){

                                    // start edit mode                                
                                    setTimeout(() => {

                                        apiTable?.startEditingCell({
                                            rowIndex: rowIndex,
                                            colKey: getEditableColumn(apiTable,column)
                                        });

                                    },0);
                                    
                                    // empty value because we are deleting
                                    node?.setDataValue(column,null);

                                    setSavedEnabled(true);
                                    setAddDisabled(true);
                                } 
    						}
    						else{
    							// ctrl+z or ctrl+y
    							if(keyCode === 8 || keyCode === 46){
    								//node?.setDataValue(column,value);
    							}
    						}
                        }
					}
				}
			}
		}
	}

	// when row selected, enable actions
	// https://www.ag-grid.com/javascript-data-grid/row-selection-api-reference/#reference--rowSelected
	// it is executed twice, for unselected row and selected row
	const handleRowSelected = (params) => {

		const apiTable = params?.api;
		const selectedRows = apiTable.getSelectedRows();
		
		if(selectedRows?.length > 0){

			// if more than one row selected, disable edit and share
			if(selectedRows?.length > 1){
				if(editable){
					setEditDisabled(true);
				}
				setShareDisabled(true);
			}
			else{
				if(editable){
					setEditDisabled(false);
				}
				setShareDisabled(false);
			}

			// enable delete
			if(editable){
				setDeleteDisabled(false);
			}			
		}
		else{

			// if no row selected, disable edit, share and delete
			if(editable){
				setEditDisabled(true);			
				setDeleteDisabled(true);
			}
			setShareDisabled(true);
		}

		// call onRowSelected on parent component
		if(onRowSelected){
			onRowSelected(apiTable);
		}
	}

	// using this when clicking delete
	const handleSelectionChanged = (params) => {
		
		//const selectedNodes = params.selectedNodes;
		const selected = params.selectedNodes?.length;

		// if no selection
		if(selected === 0){
			setEditDisabled(true);
			setSavedEnabled(false);			
			setDeleteDisabled(true);
			setShareDisabled(true);
		}

		// only enable add button if not in editing mode
		const editingCells = params?.api?.getEditingCells();
		if(!editingCells || editingCells.length === 0){
			setAddDisabled(false);
		}
	}

	// when a filter is applied
	const handleFilterChanged = (params) => {

		// params.source => quickFilter/columnFilter
		const apiTable = params?.api;
		
		//const api = gridRef?.current?.api;
		if(apiTable){
			const quickFilterApplied = apiTable?.isQuickFilterPresent();
			var applied = false;
			if(quickFilterApplied){
				applied = true;
			}
			else{			
				const columnFiltersApplied = Object.keys(apiTable?.getFilterModel()).length;				
				if(columnFiltersApplied > 0){				
					applied = true;
				}
			}
				
			// save filters if coming from columns
			if(params?.source === 'columnFilter'){
				
				if(apiTable){
					setTableConfig(apiTable,user,table,'filterState');
				}

				// when filtering, if the column was not previously filtered, it resets if you have move or sorted any column
				// to avoid this we should recover again the saved status
				// for the moment not using to improve performance. it is not a big deal
				//var columnsStates = recoverColumnsState(tableColumns);
				//setTableColumns(columnsStates);
			}

			setFiltersApplied(applied);
		}
	}
	
	// to detect change on the cell
	const handleCellValueChanged = (params) => {

		const apiTable = params?.api;
		
		if(columns[params?.colDef?.field]){

			const colDef = params?.colDef;
			const field = colDef?.field;
			const columnInfo = columns[field];
			const type = columnInfo?.type;

			// to detect "boolean" type change and open edit mode
			if(type === 'boolean'){

				// open edit mode				
				const rowIndex = params?.rowIndex;
		        apiTable?.startEditingCell({
		            rowIndex: rowIndex,
		            colKey: field
		        });		        
			}			

			// check if there are dependant values
			// cannot be used because the change is not detected while typing
			// moreover, how do you know the typing finished?
			// so it applies the change once you hit enter or save the info, not in live
			// not working for dropdown or boolean
			/*
			if(type !== 'boolean' || type !== 'boolean_badge' || type !== 'boolean_checkbox'){
        		
        		const newData = checkDependencies(field,params?.value,params?.node?.data,columns);
        		
        		api?.applyTransaction({
                    "update": newData
                });
        	}
        	*/
		}
	}

	// what to do when the value has changed. it means you click enter after editing or click on the save button
	const handleValueChanged = (e,type = 'row',action = 'edit') => {

		// save only if rowIndex is not null. null means a just deleted new row that was not on the database
		if(e?.node?.rowIndex !== null){
			// send to database
			//const apiTable = e?.api;
        	//const node = e?.node;                  
			handleButtonEdit(e,type,action);
		}
		else{
			// change button from save to edit again
			setSavedEnabled(false);
			setAddDisabled(false);
		}
	}

	// if using quotes, search exact string
	// if no quotes, search all the words, no matter the order. A B is the same as A B
	// and finds A ccc B, A B, B ccc A or B A
	const quickFilterParser = (quickFilter) => {
  
  		// quickFilter is the text on the search
  		var quickFilterParts = [];

  		// if OR, split parts and check separately
  		var split = quickFilter.split('OR');

  		split.map((text) => {

  			var textArray = [];
  
	  		const quickLen = text.length;
	  		var lastInitialQuote = -1;
	  		var lastFinalQuote = -1;
	  		var lastSpace = -1;
	  		var string = '';
	  		for(let i=0;i<quickLen;i++){
	    
	    		const char = text[i];    		

	    		// if no initial quote without end
	    		if(lastInitialQuote === lastFinalQuote){

	    			// update initial quote
	    			// if quote is not the 1st character or after space, it is not counted
	    			if(char === '"' && lastSpace === i-1){
	    				lastInitialQuote = i;
	    			}
	    			else{
	    				// if space, get word from previous space
	    				if(char === " "){

	    					if(lastSpace !== i-1){

	    						string = text.slice(lastSpace+1,i);

	    						// if string is AND, it is the same as not using it. so remove        			
	        					if(string !== 'AND'){     
	        						string = cleanString(string);   			
	    							textArray.push(string);
	    						}
	    					}

	    					lastSpace = i;
	    				}
	    			}
	    		}
	    		else{
	    			// if final quote, save sentence
	    			if(char === '"'){
	    				lastFinalQuote = i;	 
	    				string = text.slice(lastInitialQuote+1,i);  
	    				string = cleanString(string); 				
	    				textArray.push(string);
	    				lastInitialQuote = i;

	    				// it is like the space starts there to check following word
	    				lastSpace = i;
	    			}
	    		}
	  		}

	  		// 2 options:
	  		// if word not ended by closing quote
	  		// AND	  		
	  		// word not ended by space	  		
	  		if(lastSpace !== quickLen-1 && lastFinalQuote !== quickLen-1){
	  			string = text.slice(lastSpace+1,quickLen);
	  			string = cleanString(string);
    			textArray.push(string);    			
	  		}

	  		quickFilterParts.push(textArray);
	  	
	  	});

  		return quickFilterParts;
	}

	// to see if the search text matches the value of the row
	// it matches against each row
	// this is the default behaviour
	const quickFilterMatcher = (quickFilterParts,rowQuickFilterAggregateText) => {
  
  		// quickFilterParts are the strings to search for. it is an array
  		
  		// rowQuickFilterAggregateText is the appended text from all columns (returned value from quickFilterText method)

  		var result = false;
  		
  		try{

  			// every subarray is like an OR
  			// so check that one of the subarrays returns match
  			quickFilterParts.map((quickFilterPart) => {

  				// if any is true, finish
	    		if(result){
	    			return;
	    		} 

	  			// for every string from filter to search
	  			// check if matches against the appended text from row
	  			// all values on the array must match (order does not matter) => every	  		
	    		result = quickFilterPart.every((part) =>
	      			rowQuickFilterAggregateText.match(part),
	    		);	

	  		});
	  	} 
  		catch(error){
  			if(error){
    			result = false;
    		}
  		}
	  	
  		return result;
	}

	// transform every column into text to can search on it with quick filter
    // https://www.ag-grid.com/javascript-data-grid/filter-quick/
	const quickFilterText = (params) => {

		var string = '';

		try{

			var colDef = params?.colDef;

			// if hidden column, return empty string to avoid searching on it
			// appending columns it won't affect 
			if(colDef?.hide){
				return '';
			}

			var column = colDef?.field;
			
			let value;
			if(params?.data[column]){
				value = params?.data[column];
			}
			else{
				// not valid if object
				value = params?.value;
			}

			string = value;

			var type = 'text';
			
			if(columns[column]){
				var settings = columns[column];
				type = settings?.type;
			}
			
			switch(type){

                case 'boolean':
                case 'boolean_badge':
                case 'boolean_checkbox':
                    if(value){
                    	string = t('types.boolean.yes');
                    }
                    else{
                    	string = t('types.boolean.no');
                    }
                    break;

                case 'datetime':
                case 'datetime_offset':
                case 'date':                         
                    string = date(value,type === 'datetime' || type === 'datetime_offset' ? true : false,type === 'datetime_offset' ? true : false);
                    break;                

                case 'dropdown':
                	if(colDef?.refData[value]){
						string = colDef?.refData[value];						
					}
                	break;

                case 'dropdown_search':
                	// if long dropdown, it slows down the app too much
                	var len = Object.keys(colDef.refData).length;
                	if(len < 300){
	                	if(colDef?.refData[value]){
							string = colDef?.refData[value];						
						}
					}
                	break;

                case 'dropdown_multiple':
                	string = '';
                	value && value?.map((item) => {
                		string += item?.name+' ';
                	});
                	break;

				// text    
				case 'id':
                case 'html':
                case 'hour':
               	case 'price':
               	case 'percentage':
               	case 'link':
               	case 'linkshort':
               	case 'email':
               	case' phone':	
                case 'int':
                case 'float':
				default:	
					// nothing to do
                    // toString will be automatically applied
					break;
			}			
		}
		catch(error){
			if(error){
				return '';
			}
  		}

  		// remove accents  		
  		string = cleanString(string);

      	return string; 
    }    

    // when the pagination size is changed, save the value to recover after refreshing
    const handlePaginationChanged = (params) => {

    	if(params?.newPageSize){	    	
	    	const newPageSize = params.api.paginationGetPageSize();
	    	setTableConfig(api,user,table,'paginationPageSize',newPageSize);
	    }

	    // set number or rendered nodes to show buttons or not
	    setNumRenderedNodes(params?.api?.getRenderedNodes()?.length);
    }

    // after adding a row, keep on top the new one
    // the one with id null
    const handlePostSortRows = (params) => {

    	const rowNodes = params.nodes;
       
        var nextInsertPos = 0;
        
        for(var i=0;i<rowNodes.length;i++) {
            
            const id = rowNodes[i].data?.id;
            
            if(!id){            
                rowNodes.splice(nextInsertPos, 0, rowNodes.splice(i, 1)[0]);
                nextInsertPos++;
            }
        }
    }

    // to disable keys on the cells
    const suppressKeyboardEvent = (params) => {
        
        const event = params?.event;
        const editing = params?.editing;
        const apiTable = params?.api;
        const node = params?.node;
        
        // if not editing, keep default behaviour
        if(!editing) {
            return false;
        }

        // ESC key, do not stop editing because it saves with the previous values        
        if(event.key === 'Escape' || event.keyCode === 27){

            // add flag to node not to update it on stopEditing
            node.updated = false;

            // to avoid that esc removes the new values
            //event.stopPropagation();
            //event.preventDefault();

            // do not change values (true parameter)
            apiTable.stopEditing(true);

            // default behaviour for esc removing new value
            //apiTable.stopEditing(true);

            // return true to avoid default action
            return true; 
        }

        // avoid enter send api.stopEditing() because we want to check errors first
        if(event.key === 'Enter' || event.keyCode === 13){            
            // return true to avoid default action            
            handleValueChanged(params,'row','enter');
            return true; 
        }

        // false to have the key working by default if in edit mode
        return false;   
    }

    // to check errors before saving
    /*
    const getFullRowEditValidationErrors = (params) => {      
        // check errors
        /*
        // params.data contiene los nuevos valores propuestos
        const errores = validarFilaCompletaYRetornarErrores(params.data); 
        
        // Si hay errores, esta función devuelve un array de strings (los mensajes de error).
        if (errores.length > 0) {
            
            // Notifica al usuario con los mensajes
            mostrarMensajeFilaInvalida(errores);
            
            // AG Grid ve una lista de errores (un array) y CANCELA el guardado.
            return errores; 
        }
        
        // Si es válido, devuelve null o un array vacío para permitir el guardado.
        return null;
    }
    */

    // generic configuration for all columns
    // options={{scroll:true}}
    const defaultColDef = {
        
        //flex: 1, // if 0, horizontal scroll
        filter: true, // Enable filtering on all columns,
        //floatingFilter: true,
        sortingOrder: ['asc','desc'], // to remove neutral sort
        //width: 400,
        maxWidth: 1000,
        //cellStyle: {textAlign: 'center'},        

        // transform every column into text to can search on it with quick filter
        // https://www.ag-grid.com/javascript-data-grid/filter-quick/
        getQuickFilterText: quickFilterText,
        suppressKeyboardEvent: suppressKeyboardEvent        
    };

    return (        
    	<AgGridReact    	            
    		loading={loading}
    		ref={gridRef}
    		rowHeight={config?.rowheight ? config.rowheight : null}
    		getRowId={(params) => { 
        		return params?.data?.id?.toString()
    		}} // to indicate the row id is the field id on each row
            localeText={localeText}
            rowData={rows}
            columnDefs={tableColumns}
            defaultColDef={defaultColDef}            
            pagination={true}
            paginationPageSizeSelector={[10, 20, 50, 100]}
            paginationPageSize={paginationPageSize}            
            domLayout={headerFixed ? null : 'autoHeight'}
            suppressHorizontalScroll={false}
            editType='fullRow'
            onGridReady={handleGridReady}         
            //onFirstDataRendered={handleFirstDataRendered}    
            rowSelection={{
				mode: 'multiRow',
				//mode: editable ? "multiRow" : "singleRow",
				//checkboxes: editable ? true : false,
				checkboxes: true,
				enableClickSelection: true
			}}         
            onRowEditingStarted={handleEditStart} 
            onRowEditingStopped={handleEditStop}           
            onRowDoubleClicked={(params) => !modal && editable ? null : handleButtonView(params,'doubleclick')} // if null default behaviour, edit inline
            suppressClickEdit={!modal && editable ? false : true} 
            onCellKeyDown={onCellKeyDown}
            onCellValueChanged={handleCellValueChanged}            
			onRowSelected={handleRowSelected}
			onSelectionChanged={handleSelectionChanged}			
			onFilterChanged={handleFilterChanged}
			// cannot use them if adding inline because it does not open editing mode
			quickFilterParser={quickFilterParser}
			quickFilterMatcher={quickFilterMatcher}
			suppressColumnVirtualisation={true}
			suppressRowVirtualisation={true}
			onSortChanged={handleSortChanged}
			onColumnMoved={handleColumnMoved}
			onColumnResized={handleColumnResized}
			animateRows={false}
			/*
			rowClassRules={{	   
	        	'highlight-row': (params) => { return highlightRowId && params?.data?.id === highlightRowId; }
	    	}}
	    	*/
	    	onPaginationChanged={handlePaginationChanged}
	    	postSortRows={handlePostSortRows}	
	    	enableCellTextSelection={true}               
            //getFullRowEditValidationErrors={getFullRowEditValidationErrors}
            //suppressKeyboardEvent={suppressKeyboardEvent}
	    	//skipHeaderOnAutoSize={true}
	    	//onBodyScroll={handleScroll}
	    	/*
            autoSizeStrategy = {
            	autoSizeStrategy ? 
	            	{	            	
		            	type: autoSizeStrategy
						//type: 'fitCellContents',
		    			//defaultMinWidth: 100,					    			
		    			
						//columnLimits: [
						//	{
						//		colId: "tre_id",
						//		minWidth: 900,
						//	}
						//]
					}
				:
					{}
			}
			*/
	    	//enableRowPinning={true}
	    	//suppressPaginationPanel={true}
	    	/*
	    	statusBar={{
		   		statusPanels: [
		      		{ statusPanel: "agTotalAndFilteredRowCountComponent", align: "left" },
		      		{ statusPanel: "agTotalRowCountComponent" },
		      		{ statusPanel: "agFilteredRowCountComponent" },
		      		{ statusPanel: "agSelectedRowCountComponent" },
		      		{ statusPanel: "agAggregationComponent" },
		    	]
		  	}}*/
	    	//scrollbarWidth: 0			
			//enableRowPinning={true}
			//pinnedTopRowData={[{}]}
			//theme={agGridTheme}
            //paginationAutoPageSize={true}
            //suppressSizeToFit={true}
            //onRowValueChanged={handleValueChanged} //work-around for dropdowns. we have to use handleEditStop	                        
            //suppressTooltip={true}
        />
    );
}